import { z } from 'zod'

import { LOOKUP_FIELD_DEFS } from './params'

export const NEUTRAL_SENTIMENT_THRESHOLD = 0.25

export const DEFAULT_COLUMNS: Array<keyof typeof LOOKUP_FIELD_DEFS> = [
  'channel',
  'duration',
  'externalId',
  'from',
  'handledBy',
  'isOutbound',
  'method',
  'startedAt',
  'summary',
  'totalHoldTime',
  'totalHolds',
  'signals',
  'outcome',
  'missedOpportunities',
  'qualifiedLead',
]

export const FilterCollection = {
  Channels: 'channels',
  CustomerReactions: 'customerReactions',
  Direction: 'direction',
  Flags: 'flags',
  Groups: 'groups',
  Labels: 'labels',
  Methods: 'methods',
  Organization: 'organization',
  PII: 'pii',
  Roles: 'roles',
  ScorecardCriteria: 'scorecardCriteria',
  Scorecards: 'scorecards',
  Tags: 'tags',
  Users: 'users',
  Workflows: 'workflows',
  Workspaces: 'workspaces',
} as const

export type FilterCollection = (typeof FilterCollection)[keyof typeof FilterCollection]

export const filterCollection = z.enum([
  FilterCollection.Channels,
  FilterCollection.CustomerReactions,
  FilterCollection.Direction,
  FilterCollection.Flags,
  FilterCollection.Groups,
  FilterCollection.Labels,
  FilterCollection.Methods,
  FilterCollection.PII,
  FilterCollection.ScorecardCriteria,
  FilterCollection.Scorecards,
  FilterCollection.Tags,
  FilterCollection.Users,
  FilterCollection.Workflows,
  FilterCollection.Workspaces,
])
